import { render, staticRenderFns } from "./EvercamObjectDetection.vue?vue&type=template&id=6e2d0d20"
import script from "./EvercamObjectDetection.vue?vue&type=script&lang=js"
export * from "./EvercamObjectDetection.vue?vue&type=script&lang=js"
import style0 from "./EvercamObjectDetection.vue?vue&type=style&index=0&id=6e2d0d20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports